<template>
  <div class="card mb-0">
    <div class="card-title">主要近期收益表现汇总</div>
    <div class="wrap">
      <div class="flex items-center">
        <CButtons
          :dButtons1="select_1"
          :dButtons1_current="select_1_default"
          @Cbtns_sep="select1Change" />
        <div style="margin-left: 10px" v-if="select_1_default === '个股'">
          <CCascader
            @CCascader_select_node="fnCCascader_select_val_chart1"
            :default="category_cascader_val_chart1"
            :checkStrictly="false"
            :multiple="true"
            :collapsetags="true"
            :options="category_cascader_options"
            >选择类别
          </CCascader>
        </div>
        <div style="margin-left: 10px" v-if="select_1_default === '个股'">
          <CCascader
            ref="CCascader2_chart1"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            wide
            placeholder="请选择个股"
            :collapsetags="true"
            @CCascader_select_val="fnSelect_select_val_chart1_codename"
            :options="CODENAMEDATA"
            >选择对比REITs
          </CCascader>
        </div>
        <div class="date_time_pick_title">
          自定义时间
          <el-tooltip class="item" effect="dark" content="" placement="top">
            <div slot="content">只会改变自定义时间这一列</div>
            <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
          </el-tooltip>
        </div>
        <DateTimePick v-model="date_2" :clearable="false" @change="dateTimePickChange2" />
        <div class="date_time_pick_title">一年以上是否年化</div>
        <el-checkbox @change="dateTimePickChange2" v-model="checked_one"></el-checkbox>
      </div>
      <div style="margin-top: 20px">
        <div class="flex" style="justify-content: flex-end">
          <Download
            :dButtonsDownloads="dButtonsDownloads"
            :excel_info="excel_info"
            echartRefName="download-profit" />
        </div>
        <el-table
          class="table1"
          :key="select_1_default"
          :header-cell-style="tableStyle"
          :data="page_data"
          :height="OFFSETHEIGHT - 320"
          @cell-click="fnClick"
          style="width: 100%; margin-top: 4px">
          <el-table-column v-if="select_1_default === '个股'" label="代码" width="95">
            <template slot-scope="scope">
              {{ select_1_default === '个股' ? scope.row.reit_code : '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="select_1_default === '个股'" label="简称" min-width="160">
            <template slot-scope="scope">
              {{ select_1_default === '个股' ? scope.row.reitsName : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="板块" min-width="90">
            <template slot-scope="scope">
              {{ select_1_default === '个股' ? scope.row.category_2 : scope.row.reit_code }}
            </template>
          </el-table-column>
          <el-table-column
            label="现价"
            min-width="80"
            v-if="select_1_default === '个股'"
            prop="now_price"
            sortable>
            <template slot-scope="scope">
              {{ scope.row.now_price | fix2 }}
            </template>
          </el-table-column>
          <el-table-column
            label="涨跌幅"
            min-width="120"
            v-if="select_1_default === '个股'"
            prop="growth_rate"
            sortable
            class-name="line-bar5">
            <template slot-scope="scope">
              <!-- {{ scope.row.growth_rate | fix2_1 }} -->
              <div class="flex items-center justify-center h-full">
                <div :style="{ width: '60%' }" class="flex items-center h-full">
                  <div
                    class="color-bar9 left"
                    :class="{ 'opacity-0': scope.row.growth_rate >= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) * 10 ||
                          0.01
                      ),
                    }"></div>
                  <div class="line"></div>
                  <div
                    class="color-bar9 right"
                    :class="{ 'opacity-0': scope.row.growth_rate <= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) * 10 ||
                          0.01
                      ),
                    }"></div>
                </div>
                <div class="flex-1 text-left">
                  {{ scope.row.growth_rate | pct }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="select_1_default === '大类'"
            align="center"
            min-width="120"
            label="日增幅"
            prop="growth_rate"
            sortable
            class-name="line-bar5">
            <template slot-scope="scope">
              <div class="flex items-center justify-center h-full">
                <div :style="{ width: '60%' }" class="flex items-center h-full">
                  <div
                    class="color-bar9 left"
                    :class="{ 'opacity-0': scope.row.growth_rate >= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) * 3 ||
                          0.01
                      ),
                    }"></div>
                  <div class="line"></div>
                  <div
                    class="color-bar9 right"
                    :class="{ 'opacity-0': scope.row.growth_rate <= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.growth_rate), data_info.growth_rate) * 3 ||
                          0.01
                      ),
                    }"></div>
                </div>
                <div class="flex-1 text-left">
                  {{ scope.row.growth_rate | pct }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!--      <el-table-column
            label="日增幅"
            min-width="120"
            v-if="select_1_default === '大类'"
            prop="growth_rate"
            sortable>
            <template slot-scope="scope">
              <div class="flex items-center">
                <div
                  class="color-bar"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': calcPx(
                      normalizeNew(
                        scope.row.growth_rate,
                        data_info.growth_rate.max,
                        data_info.growth_rate.min
                      )
                    ),
                  }"></div>
                <div>{{ scope.row.growth_rate | pct }}</div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="now_amt"
            v-if="select_1_default === '大类'"
            label="成交额(亿元)"
            width="120"
            sortable>
            <template slot-scope="scope">
              <div class="flex items-center" style="margin-left: 20px">
                <div
                  class="color-bar"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': calcPx(normalizeNew(scope.row.now_amt, data_info.now_amt)),
                  }"></div>
                <div>{{ scope.row.now_amt | fix8 }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="now_amt"
            v-if="select_1_default === '个股'"
            label="成交额(万元)"
            width="130"
            sortable>
            <template slot-scope="scope">
              <div class="flex items-center" style="margin-left: 20px">
                <div
                  class="color-bar"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': calcPx(normalizeNew(scope.row.now_amt, data_info.now_amt) * 5),
                  }"></div>
                <div>{{ scope.row.now_amt | amt6 }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="150"
            label="换手率(不含大宗)"
            prop="turnover"
            sortable
            class-name="line-bar5">
            <template slot-scope="scope">
              <div class="flex items-center justify-center h-full">
                <div :style="{ width: '60%' }" class="flex items-center h-full">
                  <div
                    class="color-bar9 left"
                    :class="{ 'opacity-0': scope.row.turnover >= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.turnover), data_info.turnover) * x10 || 0.01
                      ),
                    }"></div>
                  <div class="line"></div>
                  <div
                    class="color-bar9 right"
                    :class="{ 'opacity-0': scope.row.turnover <= 0 }"
                    :style="{
                      '--bar_color': '#5150bf',
                      '--w': number2Pct(
                        normalizeNew(Math.abs(scope.row.turnover), data_info.turnover) * x10 || 0.01
                      ),
                    }"></div>
                </div>
                <div class="flex-1 text-left">
                  {{ scope.row.turnover | pct }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="1D" label="1D" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row['1D_s'] || 0),
                  color: scope.row['1D_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row['1D'] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="1W" label="1W" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row['1W_s'] || 0),
                  color: scope.row['1W_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row['1W'] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="1M" label="1M" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row['1M_s'] || 0),
                  color: scope.row['1M_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row['1M'] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="3M" label="3M" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row['3M_s'] || 0),
                  color: scope.row['3M_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row['3M'] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="6M" label="6M" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row['6M_s'] || 0),
                  color: scope.row['6M_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row['6M'] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="YTD" label="YTD" min-width="77" class-name="color-box" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row.YTD_s || 0),
                  color: scope.row['YTD_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row.YTD | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :prop="`${last_year}`"
            :label="`${last_year}`"
            min-width="77"
            class-name="color-box"
            sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row[last_year + '_s'] || 0),
                  color: scope.row[last_year + '_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row[last_year] | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="MAX" min-width="77" class-name="color-box" prop="MAX" sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row.MAX_s || 0),
                  color: scope.row['MAX_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row.MAX | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="自定义"
            min-width="85"
            class-name="color-box"
            prop="customize"
            sortable>
            <template slot-scope="scope">
              <div
                :style="{
                  '--box-color': getGradientColor(scope.row.customize || 0),
                  color: scope.row['MAX_s'] > 0.3 ? 'black' : '#fff',
                }">
                {{ scope.row.customize | pct }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="流通市值(亿元)" min-width="140" prop="market_cap_float" sortable>
            <template slot-scope="scope">
              <div class="flex items-center">
                <div
                  class="color-bar"
                  :style="{
                    '--bar_color': '#5ae8ed',
                    '--w': calcPx(
                      normalizeNew(scope.row.market_cap_float, data_info.market_cap_float) *
                        (select_1_default === '个股' ? 10 : 1)
                    ),
                  }"></div>
                <div>{{ scope.row.market_cap_float | fix9 }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="市值(亿元)" prop="market_cap" sortable min-width="140">
            <template slot-scope="scope">
              <div class="flex items-center">
                <div
                  class="color-bar"
                  :style="{
                    '--bar_color': '#5ae8ed',
                    '--w': calcPx(
                      normalizeNew(scope.row.market_cap, data_info.market_cap) *
                        (select_1_default === '个股' ? 10 : 1)
                    ),
                  }"></div>
                <div>{{ scope.row.market_cap | fix9 }}</div>
              </div>
            </template></el-table-column
          >
          <el-table-column label="目前分派率" prop="div_yield" sortable min-width="130">
            <template #header>
              目前分派率
              <el-tooltip class="item" effect="dark" content="" placement="top">
                <div slot="content">
                  数据备注：目前分派率为日内的<br />
                  事实分派率估值，其中为最新的<br />
                  可供分配金额ttm口径与对应的<br />
                  最新股价计算的日内分派率
                </div>
                <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex items-center">
                <div
                  v-if="scope.row.div_yield"
                  class="color-bar"
                  :style="{
                    '--bar_color': '#ff3300',
                    '--w': calcPx(scope.row.div_yield * 3),
                  }"></div>
                <div v-if="scope.row.div_yield">{{ scope.row.div_yield | fix2_1 }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import CButtons from '../Basic/CButtons_separate.vue';
import Download from '../Basic/Download.vue';
import { fnReturnTableStyle } from '@/utils/util';
import { getGradientColor, numberFix2, number2Pct, normalizeNew, getDateInfo } from '@/utils';

import CCascader from '@/components/Basic/CCascader';
import DateTimePick from '@/components/Basic/DateTimePick';

const calcPx = (n) => {
  return n * 70 + 'px';
};

/* const getMaxAndMin = (data, k) => {
  const all = data.map((item) => item[k]);
  return {
    max: Math.max(...all),
    min: Math.min(...all),
  };
}; */

// const getMaxAndMin = (data, k, abs = false) => {
//   const all = data.map((item) => {
//     if (abs) return Math.abs(item[k]);
//     return item[k];
//   });
//   console.log('ALL', all);
//   return {
//     max: Math.max(...all),
//     min: Math.min(...all),
//   };
// };

const getAll = (data, k, abs = false) => {
  const all = data.map((item) => {
    if (abs) return Math.abs(item[k]);
    return item[k];
  });
  let sum = 0;
  all.forEach((num) => (sum += num));
  return sum;
};

const getCodeMap = (code) => {
  const code_list = JSON.parse(localStorage.getItem('CODELIST'));
  let type = '';
  code_list.forEach((item) => {
    if (code == item.reitCode) {
      type = item.reitsTypeL2;
    }
  });
  return type;
};

const last_5_years = JSON.parse(localStorage.getItem('last_5_years')) || [];
const last_year = last_5_years.length > 0 ? last_5_years[last_5_years.length - 1] : 2025;
export default {
  name: 'Profitability',
  components: { CButtons, Download, CCascader, DateTimePick },
  data() {
    const now = new Date();
    const today = new Date();
    today.setFullYear(today.getFullYear() - 1);
    const FINALLYCATEGORY = JSON.parse(localStorage.getItem('FINALLYCATEGORY'));
    return {
      CODELIST: Object.freeze({}),
      ROOTFONTFIZE: '',
      OFFSETHEIGHT: 0,
      select_1: Object.freeze(['大类', '个股']),
      select_1_default: '大类',
      page_data: Object.freeze([]),
      data_info: Object.freeze({ market_cap_float: {}, market_cap: {} }),
      dButtonsDownloads: Object.freeze([
        /* {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      excel_info: Object.freeze({
        /*overviewName: '',
          excel_data:[],
          json_fields:{}
        */
      }),
      category_cascader_val_chart1: ['公募REITs'],
      category_cascader_options: FINALLYCATEGORY,
      /*       category_cascader_options: [
        {
          value: '产权类',
          label: '产权类',
          children: [
            {
              value: '物流仓储',
              label: '物流仓储',
            },
            {
              value: '产业园',
              label: '产业园',
            },
            {
              value: '租赁住房',
              label: '租赁住房',
            },
            {
              value: '消费',
              label: '消费',
            },
            {
              value: '数据中心',
              label: '数据中心',
            },
          ],
        },
        {
          value: '经营权类',
          label: '经营权类',
          children: [
            {
              value: '市政生态',
              label: '市政生态',
            },
            {
              value: '能源',
              label: '能源',
            },
            {
              value: '交通设施',
              label: '交通设施',
            },
          ],
        },
        {
          value: '公募REITs',
          label: '公募REITs',
        },
      ], */
      CODENAMEDATA: [],
      CODENAMEDATA_chart1: [],
      // 20250809
      date_2: [today, now],
      checked_one: false,
      stacking_map: {},
      last_year: last_year,
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
      // return fnReturnTableStyle(val);
    },
    x10() {
      return this.select_1_default === '个股' ? 5 : 10;
    },
  },
  filters: {
    fix2_1(n) {
      if (n === '') return '';
      return numberFix2(n * 100) + '%';
    },
    fix2(n) {
      if (n === '') return '';
      return numberFix2(n);
    },
    pct(n) {
      if (n === 0) return '';
      if (n === '') return '';
      return number2Pct(n);
    },
    fix8(n) {
      if (n === '') return '';
      return numberFix2(n / 100000000, 3);
    },
    fix9(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 3);
    },
    amt5(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 3);
    },
    amt6(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 2);
    },
  },
  methods: {
    fnCodeName() {
      // 获取对比reits
      let REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2'));
      this.CODENAMEDATA = REITsNAME;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.CODENAMEDATA_chart1 = val;
      this.loadDataBySingle();
    },
    fnCCascader_select_val_chart1(val) {
      this.category_cascader_val_chart1 = val;
      this.loadDataBySingle();
    },
    fnClick(row, column, cell) {
      if (row.reit_code) {
        let arr = [row['reitsName'], row['reit_code']];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    calcPx,
    normalizeNew,
    number2Pct,
    getGradientColor,
    select1Change(v) {
      this.select_1_default = v;
      this.loadData();
    },
    pageInit() {
      if (this._page_init) return;
      this.loadData();
    },
    getExcelInfo() {
      const overviewName = '主要近期收益表现汇总-' + this.select_1_default;
      var json_fields_1 = {
        代码: 'reit_code',
        简称: 'reitsName',
        板块: this.select_1_default === '个股' ? 'category_2' : 'reit_code',
        现价: 'now_price',
        日增幅: 'growth_rate',
        成交额: 'now_amt',
        '换手率(不含大宗)': 'turnover',
        '1D': '1D',
        '1W': '1W',
        '1M': '1M',
        '3M': '3M',
        '6M': '6M',
        YTD: 'YTD',
        2024: '2024',
        MAX: 'MAX',
        自定义: 'customize',
        流通市值: 'market_cap_float',
        市值: 'market_cap',
        目前分派率: 'div_yield',
      };
      const json_fields = this.updateJsonFields('2024', last_year, last_year, json_fields_1);
      console.log('TTTTTTTTT', json_fields);
      if (this.select_1_default !== '个股') {
        delete json_fields['代码'];
        delete json_fields['简称'];
        delete json_fields['现价'];
      } else {
        delete json_fields['日增幅'];
      }
      this.excel_info = Object.freeze({
        json_fields,
        overviewName,
        excel_data: this.page_data,
      });
    },
    async loadData() {
      this.page_data = Object.freeze([]);
      await this.fnGetStackingReturnData();
      if (this.select_1_default === '大类') {
        this.loadDataByCategory();
      } else {
        this.loadDataBySingle();
      }
    },
    async loadDataBySingle() {
      const CLASSIFY = this.category_cascader_val_chart1;
      if (CLASSIFY.length == 0) {
        this.$message.error('最少选一项');
        return;
      }
      const CODES = this.CODENAMEDATA_chart1;
      console.clear();
      console.log(CODES);
      let annualize = this.checked_one ? '1' : '0';
      const { data } = await this.$https.get(
        `/api/v2_5/period_risk_single?annualize=${annualize}&r_type_=${CLASSIFY.join(
          '&r_type_='
        )}&codes=${CODES.join('&codes=')}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      this._page_init = true;
      this.page_data = Object.freeze(data.data);
      this.page_data.forEach((item) => {
        item.customize = this.stacking_map[item.reitsName];
      });
      this.data_info = Object.freeze({
        market_cap_float: getAll(data.data, 'market_cap_float'),
        market_cap: getAll(data.data, 'market_cap'),
        now_amt: getAll(data.data, 'now_amt'),
        growth_rate: getAll(data.data, 'growth_rate', true),
        turnover: getAll(data.data, 'turnover'),
      });

      this.getExcelInfo();
    },
    async loadDataByCategory() {
      const CLASSIFY = JSON.parse(localStorage.getItem('CLASSIFY')) || [];
      let annualize = this.checked_one ? '1' : '0';
      /*   const { data } = await this.$inday
        .get(`/api/board/period-return?weight=prevclose&annualize=${annualize}`)
        .catch(() => {
          return this.$https.get(
            `/api/v2_2/period_risk_category?annualize=${annualize}&r_type_=${[
              '公募REITs',
              ...CLASSIFY,
            ].join('&r_type_=')}`
          );
        }); */
      const { data } = await this.$https.get(
        `/api/v2_2/period_risk_category?annualize=${annualize}&r_type_=${[
          '公募REITs',
          ...CLASSIFY,
        ].join('&r_type_=')}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);

      this._page_init = true;
      this.page_data = Object.freeze(data.data);
      this.page_data.forEach((item) => {
        item.customize = this.stacking_map[item.reit_code];
      });
      this.data_info = Object.freeze({
        market_cap_float: getAll(data.data, 'market_cap_float'),
        market_cap: getAll(data.data, 'market_cap'),
        now_amt: getAll(data.data, 'now_amt'),
        growth_rate: getAll(data.data, 'growth_rate', true),
        turnover: getAll(data.data, 'turnover'),
      });
      this.getExcelInfo();
    },
    //-------------20250809------------------------
    async dateTimePickChange2() {
      await this.fnGetStackingReturnData();
      if (this.select_1_default === '个股') {
        this.loadDataBySingle();
        return;
      }
      this.loadDataByCategory();
    },
    async fnGetStackingReturnData() {
      this.loading3 = true;
      let r_type_ = JSON.parse(localStorage.getItem('CLASSIFY'));
      let annualize = this.checked_one ? '1' : '0';
      let cal_function = this.select_1_default === '个股' ? 'single' : 'type';
      let str = ['公募REITs', ...r_type_].join('&r_type_=');
      const start_date = getDateInfo(this.date_2[0]).dateString;
      const end_date = getDateInfo(this.date_2[1]).dateString;
      let qs = `annualize=${annualize}&cal_function=${cal_function}&codes=&r_type_=${str}`;

      qs += `&date_=${start_date}&end_=${end_date}`;

      const { data } = await this.$https.get('/api/v2_5/' + 'stacking_return_data?' + qs);

      if (data.code !== 200) return this.$message.error(data.msg);
      this.stacking_map = {};
      data.data.forEach((item) => {
        this.stacking_map[item.reit_code] = item['总体回报'];
      });
    },

    updateJsonFields(oldKey, newKey, newValue, json_fields) {
      const keys = Object.keys(json_fields);
      const values = Object.values(json_fields);
      const index = keys.indexOf(oldKey);

      if (index !== -1) {
        keys.splice(index, 1);
        values.splice(index, 1);
        keys.splice(index, 0, newKey);
        values.splice(index, 0, newValue);

        // 重新构建对象以保持顺序
        const newObject = {};
        keys.forEach((key, i) => {
          newObject[key] = values[i];
        });

        return newObject;
      }

      return json_fields;
    },

    // 获取当前屏幕宽度
    fnGetWidth() {
      /* var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return; */
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1440 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      let OFFSETHEIGHT = element.offsetHeight;
      this.OFFSETHEIGHT = OFFSETHEIGHT;
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
  },
  created() {
    const CODELIST = JSON.parse(localStorage.getItem('CODELIST')) || {};
    const remark_CODELIST = CODELIST.reduce((p, c) => {
      const { reitCode, ...args } = c;
      p[reitCode] = args;
      return p;
    }, {});
    this.CODELIST = Object.freeze(remark_CODELIST);
    this.fnCodeName();
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    this.echart_instance && this.echart_instance.dispose();
    window.removeEventListener('resize', this.resize);
  },
};
</script>

<style scoped lang="less">
.card {
  background-color: rgba(29, 31, 37, 1);
  background-color: var(--charts_bgc);
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  height: auto;
  .card-title {
    color: var(--chart_title);
    font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
    font-weight: 700;
    // border-left: 5px solid #1573fe;
    border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
    padding-left: calc(var(--ROOTFONTFIZE) * (10 / 144));
    position: relative;
  }
  .wrap {
    width: 97%;
    margin: auto;
    padding-top: 20px;
    .container {
      margin-left: 0;
    }
  }
}
.mb-0 {
  margin-bottom: 0;
}
.pb-0 {
  padding-bottom: 0;
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.h-full {
  height: 100%;
}
/deep/.flex {
  display: flex;
}
/deep/.items-center {
  align-items: center;
}
/deep/.space-between {
  justify-content: space-between;
}
/deep/.justify-center {
  justify-content: center;
}
/deep/.color-bar {
  width: var(--w);
  min-width: 1px;
  height: 16px;
  margin-right: 10px;
  background-color: var(--bar_color);
}

/deep/.color-box {
  padding: 0 !important;
}
/deep/.color-box .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.color-box .cell > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  color: #fff;
  background-color: var(--box-color);
}
/deep/.line-bar5 {
  padding: 0 !important;
}
/deep/.line-bar5 .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.flex-1 {
  flex: 1;
}
.opacity-0 {
  opacity: 0;
}
/deep/.line {
  flex: none;
  width: 1px;
  height: 100%;
  border-left: 1px dashed #fff;
}
/deep/.text-left {
  text-align: left;
}

/deep/.color-bar9 {
  width: 50%;
  height: 16px;
  &.left {
    background: linear-gradient(to left, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
  &.right {
    background: linear-gradient(to right, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}
::v-deep .el-table th.el-table__cell > .cell {
  font-size: calc(var(--ROOTFONTFIZE) * (13 / 144));
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (13 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
.date_time_pick_title {
  margin-left: 10px;
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
}
</style>
